import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { MessageSquareTextIcon } from 'lucide-react';
const steps = [{
  n: '01',
  title: 'Tell us what has happened',
  body: 'Share the situation in your own words — a short summary is enough.'
}, {
  n: '02',
  title: 'We match you with the right lawyer',
  body: 'Your enquiry is directed to the team best suited to your matter.'
}, {
  n: '03',
  title: 'You receive clear options',
  body: 'We explain your likely next steps, risks and realistic outcomes.'
}, {
  n: '04',
  title: 'We agree the strategy & costs',
  body: 'You approve the approach, timing and how we charge before we act.'
}, {
  n: '05',
  title: 'We act, negotiate or resolve',
  body: 'We document, negotiate or advocate to move your matter forward.'
}];
export function HowWeWork() {
  return <section id="process" className="scroll-mt-24 bg-cream py-16 lg:py-24" data-id="element-172">
      <Container data-id="element-173">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end" data-id="element-174">
          <SectionHeading eyebrow="How we work" title="A clear process from first contact to resolution." intro="You should never feel unsure about what comes next. Here's exactly how working with us unfolds." data-id="element-175" />
          <Button to="/enquiry" variant="primary" size="md" className="shrink-0" data-id="element-176">
            <MessageSquareTextIcon className="h-4 w-4" data-id="element-177" />
            Start with a confidential enquiry
          </Button>
        </div>

        <ol className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-5" data-id="element-178">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.07
        }} className="relative rounded-xl border border-navy/10 bg-white p-5" data-id="element-179">
              <span className="font-serif text-2xl font-600 text-brass" data-id="element-180">
                {s.n}
              </span>
              <div className="mt-2 h-px w-8 bg-brass/40" data-id="element-181" />
              <h3 className="mt-3 font-serif text-base leading-snug text-navy" data-id="element-182">
                {s.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-ink/60" data-id="element-183">
                {s.body}
              </p>
            </motion.li>)}
        </ol>
      </Container>
    </section>;
}